import { NavItemType } from 'types/menu';

import admin from './admin';
import contents from './contents';
import fleet from './fleet';
import main from './main';
import marketing from './marketing';
import reports from './reports';
import tools from './tools';
import warehouse from './warehouse';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [main, fleet, marketing, contents, warehouse, tools, admin, reports]
};

export default menuItems;
